import React from 'react';
import Flex from 'ui/Flex/Flex';
import DataLocked from 'assets/data_locked.svg?react';
import { Typography } from '@mui/material';

type Props = {
    title: string;
    description?: string;
};

const ModuleForbidden: React.FC<Props> = ({ title, description }) => (
    <Flex
        direction="column"
        align="center"
        justify="center"
        sx={{ backgroundColor: '#EBF6FE' }}
    >
        <DataLocked
            viewBox="0 0 165 110"
            width="600"
            height="400"
            role="img"
            aria-label="locked page"
        />
        <Typography variant="h4" sx={{ mb: '0.75rem' }}>
            {title}
        </Typography>
        {description && (
            <Typography variant="subtitle1">{description}</Typography>
        )}
    </Flex>
);

export default ModuleForbidden;
